import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathRef = useRef();

  useEffect(() => {
    // Check if we are staying within the mathcounts section
    const wasMathcounts = prevPathRef.current?.startsWith('/mathcounts');
    const isMathcounts = pathname.startsWith('/mathcounts');

    // Only scroll to top if we aren't just switching mathcounts sub-pages
    if (!(wasMathcounts && isMathcounts)) {
      window.scrollTo(0, 0);
    }
    
    prevPathRef.current = pathname;
  }, [pathname]);

  return null;
}
